export enum SupportedLocales {
  en = 'en',
  ja = 'ja'
}

export enum BetaLocales {
  es = 'es'
}
